import { ColumnDef } from '@tanstack/react-table';
import { Button } from '@/components/ui/button';
import { Eye, ArrowUpDown } from 'lucide-react';
import { Link } from 'wouter';

export interface CycleSnapshot {
  id: string;
  createdAt: string;
  createdByUserId: number;
  note: string | null;
  cycleId: number;
}

export interface CycleSnapshotColumnHandlers {
  cycleId: string;
  formatDate: (date: string | Date) => string;
}

export function createCycleSnapshotColumns(
  handlers: CycleSnapshotColumnHandlers
): ColumnDef<CycleSnapshot>[] {
  const { cycleId, formatDate } = handlers;

  return [
    // Short ID column (last 6 chars)
    {
      accessorKey: 'id',
      header: ({ column }) => {
        return (
          <Button
            variant="ghost"
            onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
            className="h-8 px-2"
          >
            Short ID
            <ArrowUpDown className="ml-2 h-4 w-4" />
          </Button>
        );
      },
      cell: ({ row }) => (
        <span className="font-mono">{String(row.original.id).slice(-6)}</span>
      ),
    },
    // Created column
    {
      accessorKey: 'createdAt',
      header: ({ column }) => {
        return (
          <Button
            variant="ghost"
            onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
            className="h-8 px-2"
          >
            Created
            <ArrowUpDown className="ml-2 h-4 w-4" />
          </Button>
        );
      },
      cell: ({ row }) => (
        <span className="text-sm">{formatDate(row.original.createdAt)}</span>
      ),
    },
    // Created By column
    {
      accessorKey: 'createdByUserId',
      header: ({ column }) => {
        return (
          <Button
            variant="ghost"
            onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
            className="h-8 px-2"
          >
            Created By
            <ArrowUpDown className="ml-2 h-4 w-4" />
          </Button>
        );
      },
      cell: ({ row }) => (
        <span className="text-sm">{row.original.createdByUserId}</span>
      ),
    },
    // Note column
    {
      accessorKey: 'note',
      header: ({ column }) => {
        return (
          <Button
            variant="ghost"
            onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
            className="h-8 px-2"
          >
            Note
            <ArrowUpDown className="ml-2 h-4 w-4" />
          </Button>
        );
      },
      cell: ({ row }) => (
        <span className="text-sm">{row.original.note || '—'}</span>
      ),
    },
    // Actions column
    {
      id: 'actions',
      header: () => <div className="text-left">Actions</div>,
      cell: ({ row }) => {
        const snapshot = row.original;
        return (
          <Link href={`/cycles/${cycleId}/campaign-snapshots/${snapshot.id}`}>
            <Button
              variant="outline"
              size="sm"
              title="View snapshot"
            >
              <Eye className="h-3 w-3 mr-1" />
              View
            </Button>
          </Link>
        );
      },
      enableSorting: false,
    },
  ];
}








